import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import useAuth from 'context/useAuth';

import FocusableHeader from 'components/focusableheader/FocusableHeader';
import ContactModal from 'components/modals/ContactModal';
import { AppRoutes } from 'routes';
const originImages = window.location.origin + '/images';
const piggyBank = originImages + '/404_piggy_bank.svg';

const ConnectionFailureView = () => {
    const [displayModal, updateModalVisibility] = useState(false);

    const { signOut } = useAuth();

    const logOut = () => {
        signOut(AppRoutes.baseRoute);
    };
    return (
        <div className="error-page-connection-failure">
            <FocusableHeader>
                <span className="error-page-connection-failure-title-block" id="error.page.connection.failure.title">
                    <FormattedMessage id="error.page.connection.failure.title" />
                </span>
            </FocusableHeader>
            <div>
                <img alt="" className="img-piggy-bank" src={piggyBank} />
            </div>
            <div className="error-page-content">
                <div className="error-page-chat-block">
                    <h2 id="popup.contactus.contact.chat">
                        <FormattedMessage id="popup.contactus.contact.chat" />
                    </h2>
                    <h2 id="popup.contactus.contact.businesshours">
                        <FormattedMessage id="popup.contactus.contact.businesshours" />
                    </h2>
                </div>
                <button
                    className="error-page-button"
                    id="page-forgotCredential-button-backToLogin"
                    onClick={logOut}
                    type="button"
                >
                    <FormattedMessage id="error.page.connection.failure.credentials.login" />
                </button>
                <p className="assistance-block" id="error.page.connection.failure.for.assistance">
                    <FormattedMessage id="error.page.connection.failure.for.assistance" />
                </p>

                <button
                    className="error-page-button"
                    id="error.page.connection.failure.contact.us"
                    onClick={() => updateModalVisibility(true)}
                    type="button"
                >
                    <FormattedMessage id="error.page.connection.failure.contact.us" />
                </button>
                <ContactModal onOk={() => updateModalVisibility(false)} visible={displayModal} />
            </div>
        </div>
    );
};

export default ConnectionFailureView;
